import { ConversationCreateModel } from '@shared/models/conversation-create.model';

export class ConcernCreateModel extends ConversationCreateModel {
  concernType: string;
  resolution: string;
  resolutionDetails: string;
  // assigneeId: string;
}
